import React from 'react';
import { Box } from '@wix/design-system';

export interface DotProps {
  size?: string;
  color?: string;
}

export function Dot({ size = '8px', color = '#4666E5' }: DotProps) {
  return <Box width={size} height={size} borderRadius="50%" backgroundColor={color} />;
}
